import { createContext, useContext, useState, useEffect } from "react";
import socket from "../services/socket";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    return JSON.parse(localStorage.getItem("user")) || null;
  });

  const [cart, setCart] = useState(() => {
    return localStorage.getItem("cart") || 0;
  });

  useEffect(() => {
    if (cart) {
      localStorage.setItem("cart", cart);
    } else {
      localStorage.removeItem("cart");
    }
  }, [cart]);

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }

    if (user?._id) {
      socket.connect();
      console.log("Socket connected");
      if (user.role === 'admin' || user.role === 'supporter' || user.role === 'editor') {
        socket.emit("admin_join", user._id);
      }

      socket.emit("join", user._id);
    } else {
      socket.disconnect();
    }

    return () => {
      socket.off(); // remove all listeners
    };
  }, [user]);

  const updateBalance = async (amount) => {
    setUser((prevUser) => ({
      ...prevUser,
      balance: amount,
    }));
  };

  return (
    <UserContext.Provider value={{ user, setUser, updateBalance, setCart, cart }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
